import React, { memo } from 'react';
import {
	Route,
	Switch,
	useRouteMatch
} from 'react-router-dom';

import { log } from '../../../../services/utils';

import { useAuthState } from '../../../../contexts/AuthContext';
import { Provider as ContactsProvider } from '../../../../contexts/ContactsContext';

import ContactList from './ContactList';
import ContactDetails from './ContactDetails';

const Contacts = () => {
	let { path } = useRouteMatch();

	const { user: { permissions } } = useAuthState();

	return (
		<ContactsProvider>
			{ log( 'contacts' ) }
			<Switch>
				{ permissions.addContacts.isAvailable && permissions.addContacts.canExecute
					|| permissions.viewContacts.isAvailable && permissions.viewContacts.canExecute
					|| permissions.editContacts.isAvailable && permissions.editContacts.canExecute
					? <Route
						exact
						path={ `${ path }/:id` }
						component={ ContactDetails }
					/>
					: null
				}
				<Route
					exact
					path={ path }
					component={ ContactList }
				/>
			</Switch>
		</ContactsProvider>
	);
};

export default memo( Contacts );
